
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Icon extends Vue {
  @Prop({ type: String, required: true, default: 'mdi-check' }) public name: string;
  @Prop({ type: String, required: false, default: 'black' }) public color: string;
  @Prop({ type: String, required: false, default: '' }) public colorIntensity: string;
  @Prop({ type: String, required: false, default: 'base' }) public size: string;
  //
  // Tailwind font default sizes:
  //
  // text-xs 	font-size: 0.75rem; /* 12px */
  //            line-height: 1rem; /* 16px */
  // text-sm 	font-size: 0.875rem; /* 14px */
  //            line-height: 1.25rem; /* 20px */
  // text-base 	font-size: 1rem; /* 16px */
  //            line-height: 1.5rem; /* 24px */
  // text-lg 	font-size: 1.125rem; /* 18px */
  //            line-height: 1.75rem; /* 28px */
  // text-xl 	font-size: 1.25rem; /* 20px */
  //            line-height: 1.75rem; /* 28px */
  // text-2xl 	font-size: 1.5rem; /* 24px */
  //            line-height: 2rem; /* 32px */
  // text-3xl 	font-size: 1.875rem; /* 30px */
  //            line-height: 2.25rem; /* 36px */
}
